module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAqElEQVQ4y93UMQrCQBBG4WcSgooggihi6b08guCdFAurdDZia2UgWNhYeBG1MIFlsPDfQQsHtvweyy5Mij4dYAHMgErFbWAPPOozUnBucKniXYBvwPQnODP4quLC4PGnOPXibYAvCk7e4KGCV7G4BawDfFbxxuCBcu2E15c1c6+j0tiXr4C+N3KKjRTeSPatSM8bOf5fpOuNHNRAEwlX3CQmkgNLYA7wBG53VB4hsGa+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/searchsing.png
// module id = yaal
// module chunks = 1